/* eslint-disable max-len */
import UseAxios from '../http/http';
import { serviceName } from '../resources/serviceConstants';
import {
  AI_ACCESS_REQ_DASHBOARD,
} from '../resources/endPoint';

const getAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  token: token || '',
  isAuthToken: true,
});

export const getAiAccessRequestSummary = ({ userInfo, authToken, filterPayload }) => {
  return UseAxios({
    service: serviceName.LANDING_MS,
    method: 'post',
    url: `${AI_ACCESS_REQ_DASHBOARD}/summary`,
    headers: getAuthHeaders(authToken),
    authRequired: true,
    payload: {
      filterPayload,
      userInfo: userInfo,
    },
    csrfToken: true,
  });
};

